import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import {
  uploadPaymentFileFailure,
  uploadPaymentFileReq,
  uploadPaymentFileSuccess,
} from 'redux/slice/allocation/UploadPaymentFile.slice';
import {
  PaymentFormValues,
  UploadAllocationPayload,
} from 'redux/types/Allocation.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* uploadPaymentFile({
  payload,
}: PayloadAction<{ formData: PaymentFormValues; vendorId: string }>) {
  try {
    // const vendorId = '65c600d21766cc0045b2ba6d';
    const { formData, vendorId } = payload;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const result: UploadAllocationPayload = yield HTTPClient.PostRequest(
      `${allocationEndpoints.UPLOAD_PAYMENT_FILE(vendorId)}`,
      formData
    );
    yield put(uploadPaymentFileSuccess());

    message.success('Payment File Uploaded Successfully');
  } catch (error: any) {
    yield put(uploadPaymentFileFailure(error?.message));
    message.error('Payment File upload failed');
  }
}

export function* watchUploadPaymentFileSagas() {
  yield takeLatest(uploadPaymentFileReq.type, uploadPaymentFile);
}
